import React from "react";
import "./Services.css";

import { FaCartFlatbedSuitcase } from "react-icons/fa6";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { RiShieldCheckLine } from "react-icons/ri";

const Services = () => {
  return (
    <>
      <div className="services">
        <div className="serviceBox">
          <FaCartFlatbedSuitcase size={50} style={{ marginBottom: "20px" }} />
          <h3>Brza i sigurna dostava</h3>
          <p>Dostava za svaku narudžbu iznosi 12 KM</p>
        </div>
        <div className="serviceBox">
          <TfiHeadphoneAlt size={50} style={{ marginBottom: "20px" }} />
          <h3>24/7 Podrška</h3>
          <p>Naše ljubazno osoblje je uvijek tu za vas</p>
        </div>
        <div className="serviceBox">
          <RiShieldCheckLine size={50} style={{ marginBottom: "20px" }} />
          <h3>Moguća zamjena</h3>
          <p>Vršimo zamjenu unutar 15 dana</p>
        </div>
      </div>
    </>
  );
};

export default Services;
